<template>
  <!-- Detail pages below laptop: round back button on the card's top border (left), opposite the action pills.
       The parent card must be `relative`. Always to the list: back to its history entry (keeps page / filters / search
       from the URL) when it is there, else the list replaces this page. Not for silent login / SSO: the list is off
       limits there (the router logs the user out), so no button. Hidden while a "Back to …" pill
       (BackToDetail / BackToSearch) is shown, so there is one back button. -->
  <button v-if="!silent" type="button" aria-label="Back"
    class="laptop:hidden [.fxBackToDetail_&]:!hidden [.fxBackToSearch_&]:!hidden absolute -top-[20px] left-[10px] z-[3] w-[40px] h-[40px] p-0 rounded-full border-0 flex items-center justify-center bg-[#666666] shadow-[0px_0px_10px_0px_#00000026]"
    @click="goBack">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M19 12H5M11 6l-6 6 6 6" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
</template>

<script>
import { goBackTo } from "@/helpers/historyPositions";
import { isSilentLogin } from "@/helpers/embedMode";

export default {
  name: "DetailBackButton",
  props: {
    // the list this detail belongs to
    fallback: { type: String, default: "" },
    // a page with its own back logic (Payment Method: mobile web view / redirect_to) passes it here instead
    back: { type: Function, default: null },
  },
  computed: {
    silent: isSilentLogin,
  },
  methods: {
    goBack() {
      if (this.back) return this.back();
      goBackTo(this.$router, this.fallback);
    },
  },
};
</script>
